import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";

import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import Logo from '../../assets/images/logo.png';
import dashboardpic from '../../assets/images/music-dashboard.svg';
import dashboardActive from '../../assets/images/dashboard-active.svg';
import bagp from '../../assets/images/bag-2.png';
import jobsActive from '../../assets/images/jobs-active.svg';
import mesgp from '../../assets/images/message-2.png';
import chatActive from '../../assets/images/chat-active.svg';
import folderp from '../../assets/images/folder-open.png';
import filesActive from '../../assets/images/files-active.svg';
import aucp from '../../assets/images/auction 1.png';
import bidsActive from '../../assets/images/bids-active.svg';
import dangerp from '../../assets/images/danger.png';
import emergency from '../../assets/images/emergency.svg';
import infop from '../../assets/images/info-circle.png';
import aboutActive from '../../assets/images/about-active.svg';
import msggg from '../../assets/images/messages.png';
import faqActive from '../../assets/images/faq-active.svg';
import ddp from '../../assets/images/document-text.png';
import termsActive from '../../assets/images/terms-active.svg';
import dd1 from '../../assets/images/document-text (1).png';
import privacyActive from '../../assets/images/privacy-active.svg';
import dnormal from '../../assets/images/document-normal.png';
import msd from '../../assets/images/message-question.png';
import switchImg from '../../assets/images/switch.png';
import userimg from '../../assets/images/avatar.svg';
import Images from '../../assets/images';
import logoutsvg from '../../assets/images/logout.svg';
import useCurrentUser from 'hooks/useCurrentUser';
import { authService } from 'services';
import Homecontent, { TopHeader } from "./Homecontent";
import SwitchAccount from "components/Modals/SwitchAccount";
import logowhite from "../../assets/images/logowhite.svg";
import LogoutModal from "components/Modals/Alertpopus/Logout";


const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [show, setShow] = useState(false);
    const { user, loading, setUser, setToken } = useCurrentUser();
    const [activeNav, setActiveNav] = useState('');
    const navigate = useNavigate();
    const { pathname: currentLocation } = useLocation();
    const [isLogout, setLogout] = useState(false)
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
            setIsOpen(window.innerWidth > 991);
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Initial check

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        setActiveNav(currentLocation);
    }, [currentLocation])

    const handleClose = () => {
        setShow(false);

    };
    const handleLogout = async () => {
        try {
            await authService.logout();
            localStorage.clear();
            setUser({})
            setToken(null)
            navigate('/login');
        } catch (err) {
            console.log(err);
        }
    }

    const handleViewProfile = () => navigate('/my-profile');

    return (
        <>

            {isMobile && (
                <Navbar bg="light">
                    <Container>
                        <Navbar.Brand >
                            <Link to="/">
                                <img alt='' src={Logo} className='logo-dash mx-auto cursor-pointer' />
                            </Link></Navbar.Brand>
                        <Button className='toggle-sidebarr' variant="outline-light" onClick={handleToggle}>

                        </Button>
                    </Container>
                </Navbar>
            )}

            <Container
                fluid
                className={`sidebar ${isMobile ? "sidebar-mobile" : ""} ${isOpen ? "sidebar-open" : ""
                    }`}
            >

                <div className="logo-panel">
                    <Link to="/">
                        <img alt="" src={logowhite} className=" mt-3" />
                    </Link>
                </div>

                <div className='sidebar-inner'>
                    <Nav activeKey={activeNav} className="flex-column">
                        <Nav.Link as={Link} to="/dashboard" href="/dashboard">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/dashboard') ? dashboardActive : dashboardpic} />
                                <p className='mb-0'>Dashboard</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/my-jobs" href="/my-jobs">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/my-jobs') ? jobsActive : bagp} />
                                <p className='mb-0'>My Jobs</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/chat" href="/chat">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/chat') ? chatActive : mesgp} />
                                <p className='mb-0'>Chat</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/my-files">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/my-files') ? filesActive : folderp} />
                                <p className='mb-0'>My Files</p>
                            </div>
                        </Nav.Link>
                        {user?.roleType === 'PILOT' && <Nav.Link as={Link} to="/my-bids" href="/my-bids">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/my-bids') ? bidsActive : aucp} />
                                <p className='mb-0'>My Bids</p>
                            </div>
                        </Nav.Link>}
                        <Nav.Link as={Link} to="/emergency" href="/emergency">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/emergency') ? dangerp : emergency} />
                                <p className='mb-0'>Emergency Alerts</p>
                            </div>
                        </Nav.Link>
                        {user?.roleType === 'PILOT' && <Nav.Link href={user?.facebookGroupLink} target="_blank" rel="noopener noreferrer">
                            <div className="d-flex gap-3 align-items-center">
                                <img alt='' src={faqActive} />
                                <p className="mb-0">Skyy Pilot Help Group</p>
                            </div>
                        </Nav.Link>}

                        <Nav.Link as={Link} to="/about-us" href="/about-us" >
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/about-us') ? aboutActive : infop} />
                                <p className='mb-0'>About Us</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/faq" href="/faq">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/faq') ? faqActive : msggg} />
                                <p className='mb-0'>FAQ</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/terms-policy" href="/terms-policy">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/terms-policy') ? termsActive : ddp} />
                                <p className='mb-0'>Terms & Conditions</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/privacy-policy">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={activeNav.includes('/privacy-policy') ? privacyActive : dd1} />
                                <p className='mb-0'>Privacy Policy</p>
                            </div>
                        </Nav.Link>
                        {user?.roleType === 'PILOT' && <Nav.Link href={user?.form1099} target="_blank">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={dnormal} className='' />
                                <p className='mb-0'>1099 Form</p>
                            </div>
                        </Nav.Link>}
                        <Nav.Link as={Link} to="/contact-form" href="/contact-form">
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={msd} className='' />
                                <p className='mb-0'>Support</p>
                            </div>
                        </Nav.Link>
                        <Nav.Link onClick={() => setShow(true)}>
                            <div className='d-flex gap-3 align-items-center'>
                                <img alt='' src={switchImg} className='' />
                                <p className='mb-0'>Switch Account</p>
                            </div>

                        </Nav.Link>
                        <SwitchAccount show={show} handleClose={handleClose} />
                    </Nav>
                </div>

                <div className='bottom-sidebar'>
                    <div className='profile-div align-items-center gap-3 d-flex' onClick={handleViewProfile}>
                        <div className='user-img'>
                            <img
                                alt="User Avatar"
                                className="border border-secondary"
                                src={`${user?.baseS3Url}${user?.avatar || ""}`}
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // prevent infinite loop
                                    e.currentTarget.src = userimg; // fallback image
                                }}
                            />
                        </div>
                        <p className='mb-0'>{user?.fullName}</p>

                    </div>
                    <button
                        className='bg-transparent border-0 d-flex my-4 ms-5 logout justify-content-center gap-3 align-items-center'
                        onClick={() => { setLogout(true) }}
                    >
                        <img alt='' src={logoutsvg} />
                        <p className='mb-0 text-blue'>Logout</p>
                    </button>
                </div>
            </Container>

            <LogoutModal show={isLogout} handleClose={() => { setLogout(false) }} handleConfirm={handleLogout} />
        </>
    );
};

export default Sidebar;
